<template>
  <div>
    <el-dialog title="转移子订单" :visible.sync="customShow" fullscreen
         custom-class="transfer-orders-container default-table"
               center>
      <div class="main">
        <div class="part">
          <div>
            <div class="project-name" style="min-width: 96px;">
              <div><h3>{{ oldProject.project_name || oldProject.order_no }}</h3></div>
            </div>
            <div class="flex contact-no">
              <div class="no">合同编号：{{ oldProject.contract_no || '-' }}</div>
              <el-tag size="mini">当前项目</el-tag>
            </div>
            <div class="flex item">
              <div><span>客户：</span><span>{{ oldProject.customer_name || '-' }}</span></div>
              <div><span>项目编号：</span><span>{{ oldProject.order_no || '-' }}</span></div>
            </div>
            <div class="flex item">
              <div><span>销售：</span><span>{{ oldProject.sale || '-' }}</span></div>
              <div><span>产品名称：</span><span>{{ oldProject.product || '-' }}</span></div>
            </div>
            <div class="flex item">
              <div><span>含税收入：</span><span>{{ oldProject.payment_account || '-' }}</span></div>
              <div><span>建单时间：</span><span>{{ oldProject.created_at || '-' }}</span></div>
            </div>
          </div>
          <el-table ref="tableOld" :data="tableChildrenOld" style="width: 100%" size="mini"
                    height="calc(100% - 100px)"
                    @selection-change="handleSelectionOld">
            <el-table-column type="selection" width="55"/>
            <el-table-column prop="date" label="订单编号" width="150px">
              <template slot-scope="scope">
                <to-order-detail :order="scope.row"/>
              </template>
            </el-table-column>
            <el-table-column prop="contract_no" label="合同编号" min-width="80" show-overflow-tooltip/>
            <el-table-column prop="contract_filed_alias" label="合同状态" width="80"/>
            <el-table-column prop="name" label="含税收入" align="right" width="80">
              <template slot-scope="{row}">
                {{ $utils.numberFormat(row.payment_account, 2) }}
              </template>
            </el-table-column>
            <el-table-column prop="artist_nickname" label="红人" min-width="80" show-overflow-tooltip/>
            <el-table-column prop="brand" label="品牌" min-width="80" show-overflow-tooltip/>
            <el-table-column prop="product" label="产品" min-width="80" show-overflow-tooltip/>
            <el-table-column prop="release_timestamp_alias" label="发布日期" width="85"/>
          </el-table>
        </div>
        <div class="transfer-handel">
          <div style="text-align: center;">
            <el-button class="transfer-btn" type="primary" icon="el-icon-caret-left" circle
                       :disabled="!tableAimSelection.length" @click="handelToOld"/>
            <el-button class="transfer-btn" type="primary" icon="el-icon-caret-right" circle
                       :disabled="!tableOldSelection.length" @click="handelToAim"/>
          </div>
        </div>
        <template>
          <div class="part none-aim-main" v-if="searchWait">
            <div>
              <div style="margin-bottom: 10px; font-size: 24px; font-weight: bold;">转移目标项目</div>
              <div style="margin-bottom: 30px;font-size: 14px;color: #8a8e99;">
                输入想要转移的目标普客打包项目订单编号，勾选要转移的订单进行转移操作。
              </div>
              <el-input placeholder="请输入普客打包项目订单编号" v-model="aimProjectNo" style="width: 250px;"
                        size="mini">
                <el-button slot="append" icon="el-icon-search" @click="handelSearchAim"/>
              </el-input>
            </div>
          </div>
          <div class="part" v-else>
            <div>
              <div class="project-name" style="min-width: 96px;">
                <div>
                  <h3>{{ aimProject.project_name || aimProject.order_no }}
                    <span class="change-aim-btn" @click="handelChangeAim"><i
                        class="el-icon-edit-outline"/>更换目标</span>
                  </h3>
                </div>
              </div>
              <div class="flex contact-no">
                <div class="no">合同编号：{{ aimProject.contract_no || '-' }}</div>
                <el-tag size="mini">目标项目</el-tag>
              </div>
              <div class="flex item">
                <div><span>客户：</span><span>{{ aimProject.customer_name || '-' }}</span></div>
                <div><span>项目编号：</span><span>{{ aimProject.order_no || '-' }}</span></div>
              </div>
              <div class="flex item">
                <div><span>销售：</span><span>{{ aimProject.sale || '-' }}</span></div>
                <div><span>产品名称：</span><span>{{ aimProject.product || '-' }}</span></div>
              </div>
              <div class="flex item">
                <div><span>含税收入：</span><span>{{ aimProject.payment_account || '-' }}</span></div>
                <div><span>建单时间：</span><span>{{ aimProject.created_at || '-' }}</span></div>
              </div>
            </div>
            <el-table :key="aimProject.order_no" ref="tableAim" :data="tableChildrenAim"
                      style="width: 100%" size="mini" height="calc(100% - 100px)"
                      @selection-change="handleSelectionAim"
            >
              <el-table-column type="selection" width="55" :selectable="selectable"/>
              <el-table-column prop="date" label="订单编号" width="165px">
                <template slot-scope="scope">
                  <to-order-detail :order="scope.row"/>
                </template>
              </el-table-column>
              <el-table-column prop="contract_no" label="合同编号"/>
              <el-table-column prop="contract_filed_alias" label="合同状态" width="80"/>
              <el-table-column prop="name" label="含税收入" align="right" width="80">
                <template slot-scope="{row}">
                  {{ $utils.numberFormat(row.payment_account, 2) }}
                </template>
              </el-table-column>
              <el-table-column prop="artist_nickname" label="红人" min-width="80" show-overflow-tooltip/>
              <el-table-column prop="brand" label="品牌" min-width="80" show-overflow-tooltip/>
              <el-table-column prop="product" label="产品" min-width="80" show-overflow-tooltip/>
              <el-table-column prop="release_timestamp_alias" label="发布日期" width="85"/>
            </el-table>
          </div>
        </template>
      </div>
      <br/>
      <el-alert title="确认转移后，将会影响俩个普客打包项目，请仔细核对。" type="info" center :closable="false"/>
      <div class="dialog-footer" style="position: fixed;bottom: 20px;text-align: center;width: 100%;">
        <el-button @click="customShow = false">取 消</el-button>
        <el-button type="primary" @click="handelSubmit">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="目标项目总含税收入超出确认" :visible.sync="dialogTip" width="600px" center>
      <el-input placeholder="请输入目标项目新的总含税收入"
                :value="aimProjectPaymentAccount.new"
                @input="changeValueOnlyNumber($event)"/>
      <el-alert
          :title="`原总含税收入:${aimProjectPaymentAccount.old},现目标项目需大于所有子订单含税收入合计:${aimProjectPaymentAccount.min}`"
          type="error"
          :closable="false"/>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogTip = false">放弃转移</el-button>
        <el-button type="primary" @click="handelReSubmit">确认转移</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ToOrderDetail from "@/views/adOrder/components/ToDetail.vue";
import {getAimProject} from "@/api/adOrder";
import {getWithPukeProject, transferPukeOrderChild} from "@/api/regulars";

export default {
  name: "TransferChildOrders",
  components: {ToOrderDetail},
  props: {
    show: {
      type: Boolean,
      default() {
        return false;
      }
    },
    oldProject: { //当前项目
      type: Object,
      required: true
    },
    originChildOrders: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      customShow: false,
      dialogTip: false,
      searchWait: true,
      tableChildrenOld: [],
      tableChildrenAim: [],
      tableOldSelection: [],
      tableAimSelection: [],
      aimProjectNo: null,
      aimProjectPaymentAccount: {
        min: 0,
        old: 0,
        new: 0,
      },
      aimProject: {},
    }
  },
  watch: {
    show: function (v) {
      if (v) {
        this.tableChildrenOld = [...[], ...this.originChildOrders]
        this.customShow = this.show
      }
    },
    customShow: function (v) {
      this.$emit('update:show', v)
    },
  },
  methods: {
    resetMoney() {
      this.aimProjectPaymentAccount = {min: 0, old: 0, new: 0,}
    },
    async handelReSubmit() {
      const that = this
      if (that.aimProjectPaymentAccount.min > that.aimProjectPaymentAccount.new) {
        that.showToast({
          h: that,
          icon: "el-icon-error",
          text: '含税收入不得小于 ' + that.aimProjectPaymentAccount.min,
          duration: 3000
        });
        return false;
      }
      await that.postTransfer()
    },
    async handelSubmit() {
      const that = this
      let aim_children_new_length = 0;
      that.resetMoney();
      that.aimProjectPaymentAccount.old = that.aimProject.payment_account;
      that.tableChildrenAim.map(_ => {
        if (_.disable === undefined) {
          aim_children_new_length++;
        }
        that.aimProjectPaymentAccount.min = this.$bigNumber(that.aimProjectPaymentAccount.min).plus(_.payment_account).toNumber()
        return _.order_no
      })
      if (!aim_children_new_length) {
        that.showToast({h: that, icon: "el-icon-error", text: '无变更信息，操作失败', duration: 3000});
        return false;
      }

      if (that.aimProjectPaymentAccount.min > that.aimProjectPaymentAccount.old) {
        that.dialogTip = true
        return false;
      }

      await that.postTransfer()
    },
    async postTransfer() {
      const that = this
      const params = {
        old: {order_no: this.oldProject.order_no},
        aim: {
          order_no: this.aimProject.order_no,
          payment_account: that.aimProjectPaymentAccount.new || null,
          children: that.tableChildrenAim.map(_ => {
            return _.order_no
          })
        },
      }
      const response = await transferPukeOrderChild(params);
      if (!response.success) {
        that.showToast({h: that, icon: "el-icon-error", text: response.message, duration: 3000});
        return;
      }
      this.showToast({h: that, icon: "el-icon-success", text: '操作成功', duration: 2000});
      that.dialogTip = false
      that.customShow = false
      this.$emit('success')
    },
    handelToAim() {
      const that = this
      if (this.searchWait) {
        that.showToast({h: that, icon: "el-icon-error", text: '请先指定转移的目标项目', duration: 3000});
        return false;
      }
      that.tableChildrenAim = [...this.tableChildrenAim, ...this.tableOldSelection]
      for (let i = 0; i < this.tableOldSelection.length; i++) {
        const obj = this.tableOldSelection[i]
        const index = this.tableChildrenOld.findIndex(_ => _.order_no === obj.order_no)
        if (index !== -1) {
          this.tableChildrenOld.splice(index, 1)
        }
      }
    },
    handelToOld() {
      const that = this
      that.tableChildrenOld = [...this.tableChildrenOld, ...this.tableAimSelection]
      for (let i = 0; i < this.tableAimSelection.length; i++) {
        const obj = this.tableAimSelection[i]
        const index = this.tableChildrenAim.findIndex(_ => _.order_no === obj.order_no)
        if (index !== -1) {
          this.tableChildrenAim.splice(index, 1)
        }
      }
    },
    handleSelectionOld() {
      this.tableOldSelection = this.$refs.tableOld.selection || []
    },
    handleSelectionAim() {
      this.tableAimSelection = this.$refs.tableAim.selection || []
    },
    /**
     * 查询目标项目
     * @returns {Promise<void>}
     */
    async handelSearchAim() {
      const that = this
      this.aimProjectNo = this.aimProjectNo.trim();

      if (this.aimProjectNo === this.oldProject.order_no) {
        that.showToast({h: that, icon: "el-icon-error", text: '目标项目编号不能与当前项目编号相同！', duration: 3000});
        return;
      }
      const response = await getWithPukeProject({order_no: this.aimProjectNo})
      if (!response.success) {
        that.showToast({h: that, icon: "el-icon-error", text: response.message, duration: 3000});
        return;
      }
      const aimProject = response.model
      // if (parseInt(aimProject.customer_id) !== parseInt(this.oldProject.customer_id)) {
      //   that.showToast({
      //     h: that,
      //     icon: "el-icon-error",
      //     text: '目标项目客户与当前项目客户不一致，不可转移',
      //     duration: 3000
      //   });
      //   return;
      // }

      that.searchWait = false;
      that.aimProject = aimProject
      if (Array.isArray(that.aimProject.children)) {
        that.aimProject.children.map(_ => {
          _.disable = true
        })
      }
      that.tableChildrenAim = that.aimProject.children
    },
    handelChangeAim() {
      this.searchWait = true
      this.aimProjectNo = null
      this.aimProject = {}
      this.tableChildrenAim = []
      this.tableAimSelection = []
      this.tableOldSelection = []
      this.tableChildrenOld = [...[], ...this.originChildOrders]
    },
    selectable(row) {
      return !row.disable
    },
    changeValueOnlyNumber(val) {
      const _val = val.split(',').join('')
      // eslint-disable-next-line no-empty
      if (isNaN(Number(_val))) {

      } else {
        const _indexOf = _val.indexOf('.')
        if (_indexOf >= 0) {
          if ((_val.length - 1 - _indexOf <= 2)) {
            this.aimProjectPaymentAccount.new = _val
          }
        } else {
          this.aimProjectPaymentAccount.new = _val
        }
      }
    },
    clearOrder(){
      this.$emit('clearOrder',true)
    }
  }
}
</script>

<style lang="scss">
.transfer-orders-container {
  font-family: DINPro-Medium, DINPro Medium, sans-serif;
  height: 100%;

  .el-dialog__body {
    height: calc(100% - 110px);
  }

  .flex {
    display: flex;
  }

  .main {
    display: flex;
    justify-content: space-between;
    height: calc(100% - 83px);

    .part {
      width: calc((100% - 70px) / 2);
      height: calc(100% - 50px);

      .item {
        font-size: 12px;
        color: #8a8e99;
        line-height: 20px;

        div:first-child {
          margin-right: 12px;
          width: 250px;
        }
      }

      .project-name {
        height: 22px;
        background: #fafbff;
        border: 1px solid #f5f6fa;
        border-radius: 12px;
        padding: 0 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        font-weight: 700;
        color: #45474d;
        font-variant: tabular-nums;
      }

      .contact-no {
        font-size: 12px;
        color: rgba(0, 0, 0, .85);
        font-weight: 700;
        margin: 10px 0;

        .no {
          height: 20px;
          line-height: 20px;
          margin-right: 10px;
        }
      }
    }
  }

  .none-aim-main {
    background: #fafbff;
    border: 1px solid #f5f6fa;
    border-radius: 12px;
    text-align: center;
    color: #45474d;
    align-items: center;
    display: flex;
    justify-content: center;
  }

  .change-aim-btn {
    margin-left: 6px;
    font-size: 12px;
    color: #ff3176;
    cursor: pointer;
  }

  .transfer-handel {
    display: flex;
    align-items: center;
    justify-content: center;

    .el-button + .el-button {
      margin-top: 20px;
    }

    .transfer-btn {
      margin-left: 0;
    }
  }
}
</style>
